import { Injectable } from "@angular/core";
import { GrupoParada } from "@tivic-team/manager-ts/dist/mob/entities/parada/grupo-parada.entity";
import { GrupoParadaController } from "app/controllers/mob/grupo-parada.controller";
import { LoaderService } from "../loader.service";
import { TaxiPontosSearch } from "./taxi-pontos.search";


@Injectable({
    providedIn: "root",
})
export class TaxiPontosServices{
    constructor(
        private _grupoParadaController: GrupoParadaController,
        private _loaderService: LoaderService
    ) {}

    async find(taxiPontosSearch?: TaxiPontosSearch): Promise<Array<GrupoParada>>{
        this._loaderService.show();
        try{
            return await this._grupoParadaController.findPontostaxi((taxiPontosSearch && taxiPontosSearch.getFilters()) || null)
            .finally(() => this._loaderService.hide());
        }catch(error){
            this._loaderService.hide();
            return[];
        }
    }

    async save(grupoParada: GrupoParada): Promise<GrupoParada> {
        console.log('Loading Taxi Ponto Service...');
        this._loaderService.show();
        if(grupoParada.cdGrupoParada && grupoParada.cdGrupoParada> 0){
            console.log('Update...');
            return this._grupoParadaController.updatePontostaxi(grupoParada).finally(() => this._loaderService.hide());
        }else {
            console.log('Create...');
            return this._grupoParadaController.create(grupoParada).finally(() => this._loaderService.hide());
        }
    }

    async get(cdGrupoParada: number): Promise<GrupoParada>{
        this._loaderService.show();
        return this._grupoParadaController.getPontostaxi(cdGrupoParada).finally(() => this._loaderService.hide());
    }
}